const DEPLOYMENT_ID = "e649abdb-eb59-4e87-a7fc-4652f9681c21";
const ENVIRONMENT = "euw1";
const SNIPPET_URL = "https://apps.mypurecloud.ie/genesys-bootstrap/genesys.min.js";
const CHAT_QUEUE = "ppn member chat";
const SCRIPT_ID = "ppn-genesys-bootstrap";
const READY_TIMEOUT_MS = 15000;

export const loadGenesysSDK = () => {
  if (window._genesysMessagingReady) return Promise.resolve();
  if (window._genesysSDKPromise) return window._genesysSDKPromise;

  window._genesysSDKPromise = new Promise((resolve, reject) => {
    if (!window.Genesys) {
      window._genesysJs = "Genesys";
      window.Genesys = function () {
        (window.Genesys.q = window.Genesys.q || []).push(arguments);
      };
      window.Genesys.useHostedBundle = true;
    } else if (typeof window.Genesys === "function" && !window.Genesys.useHostedBundle) {
      window.Genesys.useHostedBundle = true;
    } else if (typeof window.Genesys !== "function") {
      window.Genesys = function () {
        (window.Genesys.q = window.Genesys.q || []).push(arguments);
      };
      window.Genesys.useHostedBundle = true;
    }

    window.Genesys = window.Genesys || function () {
      (window.Genesys.q = window.Genesys.q || []).push(arguments);
    };
    window.Genesys.t = 1 * new Date();
    window.Genesys.c = { environment: ENVIRONMENT, deploymentId: DEPLOYMENT_ID };

    let settled = false;
    const settle = (handler, payload, options = {}) => {
      if (settled) return;
      settled = true;
      const { markReady = false, resetPromise = false } = options;
      if (markReady) {
        window._genesysSDKLoaded = true;
      }
      if (resetPromise) {
        window._genesysSDKPromise = null;
      }
      handler(payload);
    };

    const readyTimeout = window.setTimeout(() => {
      settle(reject, new Error("Genesys MessagingService.ready timed out."), { resetPromise: true });
    }, READY_TIMEOUT_MS);

    window.Genesys("subscribe", "MessagingService.ready", () => {
      window.clearTimeout(readyTimeout);
      window._genesysMessagingReady = true;
      settle(resolve, undefined, { markReady: true });
    });

    window.Genesys("subscribe", "MessagingService.error", (error) => {
      console.error("Genesys messaging error:", error);
    });

    const existingScript = document.getElementById(SCRIPT_ID);
    if (existingScript) {
      existingScript.addEventListener("load", () => {
        window._genesysSDKLoaded = true;
      });
      existingScript.addEventListener("error", (event) => {
        window.clearTimeout(readyTimeout);
        settle(reject, event, { resetPromise: true });
      });
      return;
    }

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = SNIPPET_URL;
    script.async = true;
    script.charset = "utf-8";
    script.onload = () => {
      window._genesysSDKLoaded = true;
    };
    script.onerror = (event) => {
      window.clearTimeout(readyTimeout);
      settle(reject, event, { resetPromise: true });
    };
    document.head.appendChild(script);
  });

  return window._genesysSDKPromise;
};

export const setUserAttributes = ({ firstName, lastName, email, cellphone, medicalAidNumber }) => {
  window.Genesys("command", "Database.set", {
    messaging: {
      customAttributes: {
        PatientFirstName: firstName,
        PatientLastName: lastName,
        PatientEmail: email,
        PatientCellNumber: cellphone,
        MedicalAidNumber: medicalAidNumber,
        QueueName: CHAT_QUEUE,
        Queue: CHAT_QUEUE,
      },
    },
  });
};

export const sendMessage = (text) => {
  window.Genesys("command", "MessagingService.sendMessage", { message: text });
};

export const closeSession = () => {
  const onSuccess = () => {};
  const onFailure = () => {
    window.Genesys("command", "Messenger.close", {}, () => {}, () => {});
  };

  window.Genesys("command", "MessagingService.endConversation", {}, onSuccess, onFailure);
};
